<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Yeni İşbirliği Grubu Oluştur</h4>
              <p class="card-category">Yeni işbirliği grubu oluşturun.</p>



              <form class="m-5">
                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" label="Grup Kodu" placeholder="Grup Kodu" v-model="payload.code">
                    </base-input>
                  </div>


                  <div class="col-md-6">
                    <base-input type="text" label="Grup Adı" placeholder="Grup Adı" v-model="payload.title">
                    </base-input>
                  </div>


                </div>
                
                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" label="İletişim Kişisi" placeholder="İletişim Kişisi" v-model="payload.contactPerson">
                    </base-input>
                  </div>


                  <div class="col-md-6">
                    <base-input type="text" label="Açıklama" placeholder="Açıklama" v-model="payload.notes">
                    </base-input>
                  </div>  


                </div>

                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive"
                      :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                    </base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewGroup()">
                    Oluştur
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>

            </template>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        code: "",
        title: "",
        contactPerson: "",
        notes: "",
        isActive: true
      }
    }
  },
  mounted() {
  },
  methods: {
    createNewGroup() {
      CollectionService.postWidthAuth('affiliate-group', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "İşbirliği Grubu Oluşturuldu")
          this.$router.push(`/admin/affiliate-groups`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },

  }
}
</script>
<style></style>